export enum CreatorType {
    CalrisUser,
    VisuRISUser,
    System
}

export enum ExecutedByType {
    VisurisUser,
    CalrisUser
}

export enum AssignedToType {
    VisuRISUser,
    CalrisUser,
    FunctionAndArea
}

export enum CalrisType {
    Calamity,
    Registration
}

export enum LengthUnit {
    Centimeter,
    Meter,
    Hectometer,
    Kilometer
}

export enum RelationToUser {
    Owned,
    NotOwned
}

export enum FairwayPermitStatus {
    Valid = 2,
    NotValid = 5
}
export enum ValidationType {
    CheckRegex = 0,
    CheckMax = 1,
    CheckMaxLength = 2,
    CheckMinLength = 3,
    CheckMin = 4,
    CheckMinMax = 5,
    CheckSelectedWithPrecondition
}
export enum MetadataState {
    Concept = 0,
    Planned = 1,
    Active = 2,
    Finished = 3,
    Canceled = 4,
    ToSupplement = 5,
    Synchronized = 6,
    SynchronizationError = 7,
    Archived = 8,
}
export enum Lifecycle {
    Current = 1,
    Archived = 2,
    UpdateRequested = 3,
    UpdateRejected = 4,
    CancelRequested = 5,
    CancelRejected = 6
}
export enum RisindexFilter {
    DepartureArrivalPointDBB = 0,
    StrategicPoint = 1,
    BoundaryPoint = 2,
    DepartureArrivalPointOP = 3
}

export enum IdType {
    UNKONWN = "Unknown",
    ENI = "ENI",
    IMO = "IMO",
    ERN = "ERN",
    OFS = "OFS",
    HIN = "HIN",
    MMSI = "MMSI"
}

export enum ShipType {
    Passenger = 31000,
    Sea = 10000,
    Inland = 32000,
    Recreational = 20000,
    Convoy = 32200,
    Unknown = 4
}

export enum LogLevel {
    TRACE = 0,
    DEBUG = 1,
    INFO = 2,
    WARNING = 3,
    ERROR = 4,
    CRITICAL = 5
}
export enum ContainerRange {
    RNG20 = 'RNG20',
    RNG30 = 'RNG30',
    RNG40 = 'RNG40',
    TEU = 'TEU',
    UNKNW = 'UNKNW',
}
export enum ContainerStatus {
    EMPTY = '4',
    LOADED = '5'
}
export enum ErrorCode {
    DeparturePointUnknown = 0,
    ArrivalPointUnknown = 1,
    RoutePointUnknown = 2,
    NoRoutePointsAvailable = 3,
    NoVoyageCalculationPossible = 4,
    AlternativePointsAdded = 5,
    CustomerUnknown = 6,
    VATUnknown = 7,
    GoodUnknown = 8,
    PassengerShippingWithoutSubscription = 9,
    ConvertTerminalToBerth = 10,
    ConvertTerminalToFirstBerth = 11,
    ConsignmentRouteDeviatesFromMainRoute = 12,
    TypeOfPackageIsMissing = 13,
    EmailMissing = 14
}
export enum CheckOversizedTransportPermitsResultStatus {
    ValidPermitFound = 1,
    NoPermitFound = 2,
    DimensionIsNotCorrect = 3,
    IncompleteInformation = 4
}

export enum ToVerify {
    Nee = 0,
    Reis = 1 << 0,
    Romp = 1 << 1,
    Lading = 1 << 2,
    Vergunning = 1 << 3,
    Abonnement = 1 << 4,
    Klant = 1 << 5,
    Export = 1 << 6,
    Sleepkosten = 1 << 7
}

export enum SpecificTargets {
    AllMy = 0,
    Specific = 1,
    Followed = 2,
    All = 3,
    AllMyOrganisation = 4,
}

export enum TaskState {
    New = 0,
    Queued = 10,
    Busy = 20,
    Succeeded = 30,
    SucceededWithWarnings = 35,
    Failed = 90,
    NotAvailable = 99
}
export enum GridTooltipType {
    TableHeader = 0,
    GridButton = 1
}
export enum ShipClaimChangeStatus {
    New = 0,
    Approved = 1,
    Rejected = 2
}
export enum ShipClaimStatus {
    VerificationOwner = 0,
    VerificationComplete = 1,
    VerificationFailed = 2,
    VerificationCancelled = 3,
    VerificationAborted = 4,
    ContactDataConfirmation = 5,
    FlaRefRegistration = 6,
    ShipTakeOver = 7,
    ContactDataUpdateRequest = 8,
    ShipClaimChangeRequest = 9
}
export enum LocationSearchRole {
    All = 0,
    Departure = 1,
    Destination = 2,
    ViaPoint = 3
}
export enum PushSubscriptionType {
    Vapid = 0,
    Firebase = 1
}
export enum RouteSegmentDirection {
    Unknown = -1,
    Downstream = 0,
    Upstream = 1
}